import axios from 'axios';
import { API_BASE_URL, endpoints } from './config';

const apiClient = axios.create({
    baseURL: `${API_BASE_URL}/api`,
    params: { lang: 'en' }, // Default language
});
export const fetchAdvisories = async ({ severity, dateRange, page, lang }) => {
    try {
        const response = await apiClient.get(endpoints.advisories.list, {
            params: {
                severity,
                start_date: dateRange?.start,
                end_date: dateRange?.end,
                page: page || 1,
                lang,
                ordering: '-created_at',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching advisories:', error);
        throw new Error(error.response?.data?.detail || 'Failed to fetch advisories');
    }
};

export const fetchAdvisoryDetails = async (slug, lang) => {
    try {
        const response = await apiClient.get(endpoints.advisories.detail(slug), {
            params: { lang },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching advisory details:', error);
        throw new Error(error.response?.data?.detail || 'Failed to fetch advisory details');
    }
};